import { signal } from "@preact/signals-react"

export const skuGroupData = signal([])